import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../data/content";
import Reveal from "./Reveal";

const ProjectCard = ({ project, index }) => {
  return (
    <motion.a
      href="#contact"
      data-testid={`project-card-${project.id}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="group relative block bg-beige-light border border-royal/10 hover:border-gold transition-colors duration-500"
    >
      <div className="relative h-64 overflow-hidden">
        <img
          src={project.image}
          alt={project.name}
          className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[900ms]"
        />
        <div className="absolute top-4 left-4 flex items-center gap-2">
          <span className="w-2 h-2 bg-gold rounded-full" />
          <span className="font-accent text-xs uppercase tracking-[0.2em] text-royal bg-beige-light/90 px-3 py-1.5">
            {project.status}
          </span>
        </div>
        <div className="absolute top-4 right-4">
          <span className="font-accent text-xs uppercase tracking-[0.2em] text-beige-light bg-royal/85 px-3 py-1.5">
            {project.type}
          </span>
        </div>
      </div>

      <div className="p-7">
        <h3 className="font-display text-3xl text-royal flex items-center gap-3">
          {project.name}
          <ArrowUpRight
            size={26}
            className="text-gold opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500"
          />
        </h3>
        <p className="mt-3 text-titanium leading-relaxed">{project.location}</p>
        <div className="mt-5 pt-5 border-t border-royal/10 flex items-center justify-between">
          <span className="font-accent text-xs uppercase tracking-[0.22em] text-titanium">
            Completion
          </span>
          <span className="font-accent text-sm uppercase tracking-[0.18em] text-royal">
            {project.completion}
          </span>
        </div>
      </div>
    </motion.a>
  );
};

const Projects = () => {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-24 bg-beige"
    >
      <Reveal>
        <div className="flex items-center gap-4 mb-6">
          <span className="h-px w-12 bg-gold" />
          <span className="font-accent text-sm uppercase tracking-[0.28em] text-gold">
            Partnership Projects
          </span>
        </div>
      </Reveal>
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 md:mb-20">
        <Reveal delay={0.05}>
          <h2 className="font-display text-royal text-4xl md:text-5xl lg:text-6xl leading-[1.08] max-w-2xl">
            Building success together through{" "}
            <span className="italic text-gold-gradient">strategic partnerships.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-titanium leading-relaxed max-w-md text-lg">
            Each development is carefully designed to maximize value — offering
            modern living spaces and strong return potential for investors.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {PROJECTS.map((p, i) => (
          <ProjectCard key={p.id} project={p} index={i} />
        ))}
      </div>
    </section>
  );
};

export default Projects;
